import { MealTime } from "@/clients/models/MealTime";
import SaveButton from "@/components/button/save-button";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import useFavouriteFoodProfile from "@/features/go-to/hooks/use-favourite-food-profile";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MealGroupList } from "../../components/meal-group-list";

export default function FavouriteFoodProfile() {
  const { mealTime } = useParams<{ mealTime: MealTime }>();
  const navigation = useIonRouter();
  const { form, handleFormSubmit, isGenerating, isValid, isLoading } =
    useFavouriteFoodProfile({
      mealTime,
      onSuccess: () => {
        navigation.push(
          `/profiling/favourites/candidates-creating/${mealTime}`,
          "forward",
          "replace",
        );
      },
    });

  return (
    <PageContainer>
      <PageTitleComponent
        title={`My Favourites  ${mealTime.toLowerCase()}`}
        description={`Add your favourite ${mealTime.toLowerCase()} meals that you want to include in your meal plan.`}
      />

      <FormProvider {...form}>
        <form
          className="w-full flex-1 flex flex-col gap-4 justify-between"
          onSubmit={handleFormSubmit}
        >
          {isLoading ? (
            <div className="w-full flex flex-col gap-4">
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
              <IonSkeletonText animated className="h-16" />
            </div>
          ) : (
            <MealGroupList />
          )}

          <SaveButton
            text="Save & Continue"
            type="submit"
            position="fixed"
            disabled={isGenerating || !isValid || isLoading}
          />
        </form>
      </FormProvider>
    </PageContainer>
  );
}
